var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-copie-double';
                    var viewUrl = 'sprite.svg#view-logo-copie-double';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-copie-double#logo-copie-double';
                            viewUrl = 'sprite.svg?logo-copie-double#view-logo-copie-double';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 1850 750',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };